import React from "react";

function GameCard({ game, onGiftClick }) {
  return (
    <div style={{ backgroundColor: "#2a475e", borderRadius: "6px", display: "flex", padding: "1rem", alignItems: "center" }}>
      <img src={game.img} alt={game.title} style={{ width: "280px", borderRadius: "4px", marginRight: "1.5rem" }} />
      <div style={{ flex: 1 }}>
        <h2 style={{ margin: "0 0 0.5rem", color: "#fff" }}>{game.title}</h2>
        <p style={{ marginBottom: "1rem", whiteSpace: "pre-line" }}>{game.description}</p>
        <button
          onClick={() => onGiftClick(game)}
          style={{
            backgroundColor: "#66c0f4",
            color: "#1b2838",
            border: "none",
            padding: "0.6rem 1rem",
            borderRadius: "4px",
            fontWeight: "bold",
            cursor: "pointer",
            fontSize: "1rem",
          }}
        >
          🎁 Převzít dárek
        </button>
      </div>
    </div>
  );
}

export default GameCard;
